/* eslint-disable */
import autosize from 'autosize';

export default {
  inputsEvents() {
    const textInputs = document.querySelectorAll('[data-text]');
    const fileInputs = document.querySelectorAll('[data-file]');
    const checkInputs = document.querySelectorAll('[data-check]');
    const selectors = document.querySelectorAll('[data-select]');
    const $self = this;
    const changeEvent = new Event('change');

    autosize(document.querySelectorAll('textarea'));

    for (let i = 0; i < textInputs.length; i++) {
      textInputs[i].addEventListener('change', function (e) {
        if (this.value.trim().length > 0) {
          this.parentElement.classList.add('full');
        } else {
          this.parentElement.classList.remove('full');
        }

        if (
          this.closest('.form-input').classList.contains(
            'form-input--has-error'
          )
        ) {
          this.closest('.form-input').classList.remove('form-input--has-error');
        }
      });
    }

    for (let i = 0; i < textInputs.length; i++) {
      textInputs[i].addEventListener('keydown', function (e) {
        if (this.value.trim().length > 0) {
          this.parentElement.classList.add('full');
        } else {
          this.parentElement.classList.remove('full');
        }

        if (
          this.closest('.form-input').classList.contains(
            'form-input--has-error'
          )
        ) {
          this.closest('.form-input').classList.remove('form-input--has-error');
        }
      });
    }

    for (let i = 0; i < textInputs.length; i++) {
      textInputs[i].addEventListener('keyup', function (e) {
        if (this.value.trim().length > 0) {
          this.parentElement.classList.add('full');
        } else {
          this.parentElement.classList.remove('full');
        }

        if (
          this.closest('.form-input').classList.contains(
            'form-input--has-error'
          )
        ) {
          this.closest('.form-input').classList.remove('form-input--has-error');
        }
      });
    }

    for (let i = 0; i < textInputs.length; i++) {
      textInputs[i].addEventListener('focusin', function (e) {
        this.parentElement.classList.add('focus');
      });
    }

    for (let i = 0; i < selectors.length; i++) {
      selectors[i].addEventListener('change', function (e) {
        this.closest('.form-input').classList.remove('form-input--has-error');
      });
    }

    for (let i = 0; i < textInputs.length; i++) {
      textInputs[i].addEventListener('focusout', function (e) {
        this.parentElement.classList.remove('focus');
      });
    }

    for (let i = 0; i < fileInputs.length; i++) {
      fileInputs[i].addEventListener('change', function (e) {
        const parent = this.closest('.form-input--file');
        const targetInput = parent.querySelector('[data-text]');
        targetInput.value = $self.fileName(this.value);
        targetInput.dispatchEvent(changeEvent);
      });
    }

    for (let i = 0; i < checkInputs.length; i++) {
      checkInputs[i].addEventListener('change', function (e) {
        if (
          this.closest('.form-input').classList.contains(
            'form-input--has-error'
          ) &&
          this.checked
        ) {
          this.closest('.form-input').classList.remove('form-input--has-error');
        }
      });
    }

    const selectItems = document.querySelectorAll('.form-input--select');
    if(selectItems) {
      selectItems.forEach(selector => {
        var x, i, j, l, ll, selElmnt, a, b, c;
        /*look for any elements with the class "custom-select":*/
        x = selector
          selElmnt = x.getElementsByTagName("select")[0];
          /*bail out if the wrapper has no select at all, otherwise the throw
          below aborts the whole init chain (initForm included):*/
          if (!selElmnt) return;
          ll = selElmnt.length;
          /*for each element, create a new DIV that will act as the selected item:*/
          a = document.createElement("DIV");
          a.setAttribute("class", "select-selected");
          /*selectedIndex can be -1 (Safari + a placeholder option, or after
          select.value is set to a value no option has), and options[-1] is
          undefined - fall back to the first option:*/
          a.innerHTML = (selElmnt.options[selElmnt.selectedIndex] || selElmnt.options[0] || { innerHTML: "" }).innerHTML;
          x.appendChild(a);
          /*for each element, create a new DIV that will contain the option list:*/
          b = document.createElement("DIV");
          b.setAttribute("class", "select-items select-hide");
          for (j = 1; j < ll; j++) {
            /*for each option in the original select element,
            create a new DIV that will act as an option item:*/
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function(e) {
                /*when an item is clicked, update the original select box,
                and the selected item:*/
                var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                for (i = 0; i < sl; i++) {
                  if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    yl = y.length;
                    for (k = 0; k < yl; k++) {
                      y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                  }
                }
                s.dispatchEvent(changeEvent);
                h.click();
            });
            b.appendChild(c);
          }
          x.appendChild(b);
          a.addEventListener("click", function(e) {
              /*when the select box is clicked, close any other select boxes,
              and open/close the current select box:*/
              e.stopPropagation();
              closeAllSelect(this);
              this.nextSibling.classList.toggle("select-hide");
              this.classList.toggle("select-arrow-active");
            });
        
        function closeAllSelect(elmnt) {
          /*a function that will close all select boxes in the document,
          except the current select box:*/
          var x, y, i, xl, yl, arrNo = [];
          x = document.getElementsByClassName("select-items");
          y = document.getElementsByClassName("select-selected");
          xl = x.length;
          yl = y.length;
          for (i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
              arrNo.push(i)
            } else {
              y[i].classList.remove("select-arrow-active");
            }
          }
          for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
              x[i].classList.add("select-hide");
            }
          }
        }
        /*if the user clicks anywhere outside the select box,
        then close all select boxes:*/
        document.addEventListener("click", closeAllSelect);

      })
    }
  },
  fileName(fullPath) {
    if (fullPath) {
      var startIndex =
        fullPath.indexOf('\\') >= 0
          ? fullPath.lastIndexOf('\\')
          : fullPath.lastIndexOf('/');
      var filename = fullPath.substring(startIndex);
      if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
        filename = filename.substring(1);
      }
      return filename;
    } else {
      return '';
    }
  },
};
